import { Component } from '@angular/core';

@Component({
    selector: 'stby-modal-title',
    templateUrl: './modal-title.html',
})
export class ModalTitle {}
